import dayjs from 'dayjs'
import capitalize from 'lodash/capitalize'
import isEmpty from 'lodash/isEmpty'
import isUndefined from 'lodash/isUndefined'
import i18n from './i18n'

export const urlEncode = data => {
    let ret = []
    for (let i in data) {
        if (!isUndefined(data[i])) {
            ret.push(encodeURIComponent(i) + '=' + encodeURIComponent(data[i]))
        }
    }
    return ret.join('&')
}

export const urlParams = (url, params) => {
    const delimiter = url.indexOf('?') === -1 ? '?' : '&'
    return `${url}${delimiter}${urlEncode(params)}`
}

export const someEmpty = args => {
    for (let i = 0; i < args.length; i++) {
        if (isEmpty(args[i])) {
            return true
        }
    }
    return false
}

// Field validations
export const required = value => (!!value ? undefined : 'errorsList.required')
export const email = value =>
    value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? 'errorsList.incorrectemail' : undefined
export const number = value => (value && isNaN(Number(value)) ? 'errorsList.neednumber' : undefined)
export const biggerThanZero = value => (value > 0 ? undefined : 'errorsList.greatestthenzero')
export const phoneNumber = value => (value && !/^\+?[0-9]\d{8,14}$/i.test(value) ? 'errorsList.incorrectformat' : undefined)

/**
 * Returns UTC midnight timestamp
 *
 * @param {Date} date - date to calculate
 * @returns {number} UTC midnight timestamp
 */
export const getUTCTime = date =>
    dayjs(date)
        .add(-date.getTimezoneOffset(), 'minute')
        .toDate()
        .setUTCHours(0, 0, 0, 0)

export const formatToRuLocaleString = date =>
    capitalize(
        date.toLocaleString(i18n.language, {
            weekday: 'short',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            timezone: 'UTC'
        })
    )



// WEBPACK FOOTER //
// ./utils.js